export const CRMcustomerContacts = [
  {
    firstName: "sree",
    lastName: "vishnu",
    email: "info@sunsai.com",
    company: "Sunsai Enterprises",
    phone: "9876543210",
    position: "Manager",
    lastLogin: "2025-03-25 10:00:00",
    active: true,
  },
  {
    firstName: "vamsi",
    lastName: "kumar",
    email: "tara_dss@yahoo.co.in",
    company: "Crescent Marketing",
    phone: "9123456789",
    position: "Sales Head",
    lastLogin: "2025-03-24 12:30:00",
    active: true,
  },
  {
    firstName: "krishna",
    lastName: "kumar",
    email: "cswireless5@gmail.com",
    company: "Cognus Systems LLP",
    phone: "9765432109",
    position: "CTO",
    lastLogin: "2025-03-23 14:20:00",
    active: true,
  },
  {
    firstName: "suresh",
    lastName: "babu",
    email: "accounts@gayathiengg.com",
    company: "Gayathri Engineering Works",
    phone: "9856741203",
    position: "Accountant",
    lastLogin: "2025-03-22 16:45:00",
    active: true,
  },
  {
    firstName: "ramesh",
    lastName: "babu",
    email: "sre.chivukula@gmail.com",
    company: "Smt. Godavari Devi Saraf High School",
    phone: "9542677787",
    position: "Principal",
    lastLogin: "2025-03-21 09:10:00",
    active: true,
  },
  {
    firstName: "krishna",
    lastName: "kumar",
    email: "info@greenbolt.co",
    company: "GreenBOLT Energy Pvt. Ltd.",
    phone: "7702207582",
    position: "Operations Manager",
    lastLogin: "2025-03-20 11:30:00",
    active: true,
  },
  {
    firstName: "chalapathi",
    lastName: "rao",
    email: "alnoorhirani@gmail.com",
    company: "Indervelly Public School",
    phone: "9542935888",
    position: "Administrator",
    lastLogin: "2025-03-19 13:20:00",
    active: true,
  },
  {
    firstName: "ragava",
    lastName: "rao",
    email: "Kamal.Kishore@kalixa.com",
    company: "KALIXA SERVICES INDIA PRIVATE LIMITED",
    phone: "9874123650",
    position: "Director",
    lastLogin: "2025-03-18 15:45:00",
    active: true,
  },
];
